export default {
  groupName: 'insurance',
  appName: 'Insurance',
  baseRoute: '/dashboard/insurance',
  label: 'Geico Ad Effect Tracker',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Geico Ad Effect Tracker'
};



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/main.js